module.exports = __webpack_public_path__ + "media/recipes/136-62d35c3c.png";